import { h, Component } from "preact";

import LikeButton from "./LikeButton";
import ShareButton from "./ShareButton";
import CollectionButton from "./CollectionButton";
import ReportButton from "./ReportButton";

interface Props {
    content_type: string;
    id: number;
    like_count: number;
    liked: boolean;
    quote: string;
    originator: string;
    page_url: string;
    networks: string[];
    enable_collections: boolean;
    enable_report: boolean;
}

interface State {}

export default class ActionBar extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render(props: Props, state: State) {
        return (
            <div class="action-bar">
                <LikeButton
                    id={props.id}
                    content_type={props.content_type}
                    like_count={props.like_count}
                    liked={props.liked}
                />

                <ShareButton
                    content_type={props.content_type}
                    id={props.id}
                    quote={props.quote}
                    originator={props.originator}
                    page_url={props.page_url}
                    networks={props.networks}
                />

                {props.enable_collections && <CollectionButton id={props.id} />}

                {props.enable_report && <ReportButton id={props.id} />}
            </div>
        );
    }
}
